import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'
import axios from 'axios'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {toast} from 'react-toastify'

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id')

  useEffect(() => {
    if (sessionId) {
      storeTransaction(sessionId)
    }
  }, [sessionId])

  const storeTransaction = async (session_id: string) => {
    try {
      const response = await axios.post(API_ENDPOINTS.STORE_TRANSACTION(), {
        session_id,
      })
      toast.success(response.data.message)
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Transaction failed')
    }
  }

  return (
    <div>
      <h2>Payment Successful!</h2>
      <p>Thank you for your purchase.</p>
    </div>
  )
}

export default PaymentSuccess
